<template>
  <div>
    <Navbar :forceBg="true" />
    <section class="conteudo text-left">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>Instalando na TV Box Android</h1>

            <p>
              Pra você aproveitar a nossa Lista de IPTV na sua TV BOX ANDROID é
              muito simples e temos algumas opções:
            </p>
          </div>
        </div>

        <div class="row">


            <div class="col-md-12">
                <meuplayer></meuplayer>
                <xciptv></xciptv>

            </div>

        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>
<script>
import Navbar from "@/components/navbar";
import Footer from "@/components/footer";

import meuplayer from "@/views/tutoriais/apps/meuplayer.vue";
import xciptv from "@/views/tutoriais/apps/xciptv.vue";

export default {
  components: {
    Navbar,
    Footer,
    meuplayer,
    xciptv
  },
};
</script>